export default __webpack_public_path__ + "static/media/galeria-bg-1.4165f731.png";